/* eslint-disable @typescript-eslint/naming-convention */
import { useContext, useCallback } from "react";
import { AnalyticsContext } from "@swiggy-private/checkout-core";
import { ReviewedCart } from "@cart-client/interfaces/Cart";
import { CLICK_ACTIONS, IMPRESSION_ACTIONS, LABELS, SCREEN_NAME } from "@cart-client/analytics/constants";

export function useMenuCalloutAnalytics(cartResponse: ReviewedCart | null) {
    const { clickEvent, impressionEvent } = useContext(AnalyticsContext);
    const cartId = cartResponse?.data?.cartId;
    const originalCartId = cartResponse?.data?.originalCartId;
    const is_bulk_cart = cartResponse?.data?.is_bulk_cart || false;
    const is_splittable_bulk_order = cartResponse?.data?.is_splittable_bulk_order || false;

    const onItemsBannerImpression = useCallback(
        (message?: string) => {
            impressionEvent({
                category: SCREEN_NAME.CHECKOUT,
                action: IMPRESSION_ACTIONS.IMPRESSION_ITEMS_BANNER,
                context: JSON.stringify({
                    cartId,
                    originalCartId,
                    message,
                }),
            });
        },
        [impressionEvent, cartId, originalCartId],
    );

    const onItemsBannerClick = useCallback(
        (message?: string) => {
            clickEvent({
                category: SCREEN_NAME.CHECKOUT,
                action: CLICK_ACTIONS.CLICK_ITEMS_BANNER,
                label: LABELS.SEE_HOW,
                context: JSON.stringify({
                    cartId,
                    originalCartId,
                    message,
                }),
            });
        },
        [clickEvent, cartId, originalCartId],
    );

    const onHalfCardBannerImpression = useCallback(() => {
        impressionEvent({
            category: SCREEN_NAME.CHECKOUT,
            action: IMPRESSION_ACTIONS.IMPRESSION_ITEMS_BANNER_HALF_CARD,
            context: JSON.stringify({
                cartId,
                originalCartId,
                is_bulk_cart,
                is_splittable_bulk_order,
            }),
        });
    }, [impressionEvent, cartId, originalCartId, is_bulk_cart, is_splittable_bulk_order]);

    const onHalfCardBannerCtaClick = useCallback(() => {
        clickEvent({
            category: SCREEN_NAME.CHECKOUT,
            action: CLICK_ACTIONS.CLICK_ITEMS_BANNER_HALF_CARD_CTA,
            label: LABELS.OK_GOT_IT,
            context: JSON.stringify({
                cartId,
                originalCartId,
                is_bulk_cart,
                is_splittable_bulk_order,
            }),
        });
    }, [clickEvent, cartId, originalCartId, is_bulk_cart, is_splittable_bulk_order]);

    return {
        onItemsBannerImpression,
        onItemsBannerClick,
        onHalfCardBannerImpression,
        onHalfCardBannerCtaClick,
    };
}
